import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ApplicationUserRelationUpdatePage = lazy(() => import('../views/update/ApplicationUserRelationUpdatePage'));

export function ApplicationUserRelationUpdatePageLazy() {
	return (
		<PageSuspense>
			<ApplicationUserRelationUpdatePage />
		</PageSuspense>
	);
}
